"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColliderComponent = void 0;
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _eventBusComponent2 = require("../events/event-bus-component");
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _healthComponent = /*#__PURE__*/new WeakMap();
var _eventBusComponent = /*#__PURE__*/new WeakMap();
/**
 * A simple component for handling when collisions between two different
 * game objects in our game.
 */
class ColliderComponent {
  constructor(healthComponent, eventBusComponent) {
    _classPrivateFieldInitSpec(this, _healthComponent, void 0);
    _classPrivateFieldInitSpec(this, _eventBusComponent, void 0);
    _classPrivateFieldSet(_healthComponent, this, healthComponent);
    _classPrivateFieldSet(_eventBusComponent, this, eventBusComponent);
  }
  collideWithEnemyShip() {
    if (_classPrivateFieldGet(_healthComponent, this).isDead) {
      return;
    }
    _classPrivateFieldGet(_healthComponent, this).die();
  }
  collideWithEnemyProjectile() {
    if (_classPrivateFieldGet(_healthComponent, this).isDead) {
      return;
    }
    _classPrivateFieldGet(_healthComponent, this).hit();
    _classPrivateFieldGet(_eventBusComponent, this).emit(_eventBusComponent2.CUSTOM_EVENTS.SHIP_HIT);
  }
}
exports.ColliderComponent = ColliderComponent;